import _slicedToArray from "/Users/akhil/code/profile/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useState } from "react";
/**
 * React hook to manage boolean (on - off) states
 *
 * @param initialState the initial boolean state value
 */

export function useBoolean(initialState) {
  if (initialState === void 0) {
    initialState = false;
  }

  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var on = useCallback(function () {
    setValue(true);
  }, []);
  var off = useCallback(function () {
    setValue(false);
  }, []);
  var toggle = useCallback(function () {
    setValue(function (prev) {
      return !prev;
    });
  }, []);
  return [value, {
    on: on,
    off: off,
    toggle: toggle
  }];
}